var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("div", { staticClass: "checkbox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.isRoomRestricted,
              expression: "isRoomRestricted",
            },
          ],
          attrs: { type: "checkbox", disabled: _vm.field.disabled },
          domProps: {
            checked: Array.isArray(_vm.isRoomRestricted)
              ? _vm._i(_vm.isRoomRestricted, null) > -1
              : _vm.isRoomRestricted,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.isRoomRestricted,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isRoomRestricted = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isRoomRestricted = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isRoomRestricted = $$c
              }
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.isRoomRestricted
        ? _c("v-autocomplete", {
            staticClass: "mt-3",
            attrs: {
              items: _vm.rooms,
              "item-text": "name",
              "item-value": "key",
              loading: _vm.loading,
              disabled: _vm.field.disabled,
              multiple: "",
              chips: "",
              "small-chips": "",
              "deletable-chips": "",
              outlined: "",
              dense: "",
            },
            model: {
              value: _vm.selectedRoomKeys,
              callback: function ($$v) {
                _vm.selectedRoomKeys = $$v
              },
              expression: "selectedRoomKeys",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }